// PARAQTA — навигация (бет ауыстыру + tab ауыстыру).
// show() ішінде керекті module-дердің loadX функциялары импортталады.

import { loadLeaders } from '../features/rankings/index.js';
import { loadGroups } from '../features/groups/index.js';
import { renderAchievements } from '../features/achievements/index.js';
import { loadProfile } from '../features/profile/index.js';
import { loadCatalog, loadGenres } from '../features/catalog/index.js';
import { loadDawysPage } from '../features/dawys/index.js';
import { loadFeed } from '../features/feed/index.js';
import { setActiveBnav } from '../features/bottom-nav/index.js';
import { loadAdmin } from '../features/submissions/index.js';
import { loadJandos } from '../features/jandos/index.js';
import { loadMarathon } from '../features/marathon/index.js';
import { loadPublicProfile } from '../features/public-profile/index.js';
import { loadWrapped } from '../features/wrapped/index.js';
import { loadMonthlyWrapped } from '../features/monthly-wrapped/index.js';
import { track } from './track.js';

// Алдыңғы бет (ішкі беттердің «артқа» батырмасына) — show() толтырады.
let _prevPage = '';
export function prevPage() { return _prevPage; }

// 04.10.26: 6 өлі бет ӨШІРІЛДІ (Сарапшы аудиті ops/audit/better-2026-10.md).
// Ескі сілтеме, бетбелгі, hash, «соңғы ашылған бет» (localStorage) және кодтағы
// кез келген ескі шақыру (мыс. dash-қа) — 404/бос бет емес, Оқуға түседі.
export const DEAD_PAGES = ['dash', 'books', 'cities', 'stats', 'popular', 'search'];

export function show(p) {
  if (DEAD_PAGES.includes(p)) p = 'oqu';
  // 31.10 Apple 3.1.1: iOS/Android қолданбада ақылы беттер (Жан дос, марафон төлемі) мүлде ашылмайды —
  // кодтың кез келген жерінен show('jandos') шақырылса да (мәзір, карточка, рейтинг, айлық есеп).
  if ((p === 'jandos' || p === 'premium') && /PARAQTA-App\//.test(navigator.userAgent || '')) p = 'oqu';
  // Аналитика: бет көру (catalog = кітапхана)
  try { track('view', { page: p }); } catch (_) {}
  // Stage 7.5 Bug 7: соңғы кірген бетті сақтау (reload қайтару)
  try {
    const persistable = ['oqu','catalog','profile','groups','feed','jandos','marathon','leaders'];
    if (persistable.includes(p)) localStorage.setItem('paraqta:last_page', p);
  } catch (_) {}

  // Алдыңғы бетті есте сақтау — ішкі беттердің «артқа» батырмасы үшін.
  // (Роутер history-ге жазбайды, сондықтан history.back() сайттан шығарып жібереді.)
  try {
    const cur = document.querySelector('.pg.on');
    if (cur && cur.id && cur.id !== 'pg-' + p) _prevPage = cur.id.replace(/^pg-/, '');
  } catch (_) {}

  document.querySelectorAll('.pg').forEach(e => e.classList.remove('on'));
  document.querySelectorAll('.navlinks button, .nav-tab').forEach(e => e.classList.remove('on'));
  const pg = document.getElementById('pg-' + p); if (pg) pg.classList.add('on');
  const nb = document.getElementById('nb-' + p); if (nb) nb.classList.add('on');
  setActiveBnav(p);

  // v2: Бүгін / Профиль / Каталог / Жанр / Автор беттеріне арналған body class.
  // `:has()` selector ескі браузерлерде жоқ — JS-fallback class.
  document.body.classList.toggle('on-profile-v2', p === 'profile');
  document.body.classList.toggle('on-catalog-v2', p === 'catalog');
  document.body.classList.toggle('on-genre-v2', p === 'genre');
  document.body.classList.toggle('on-author-v2', p === 'author');
  document.body.classList.toggle('on-feed-v2', p === 'feed');
  document.body.classList.toggle('on-jandos-v2', p === 'jandos');
  document.body.classList.toggle('on-oqu-v2', p === 'oqu');
  document.body.classList.toggle('on-groups-v2', p === 'groups');
  document.body.classList.toggle('on-leaders-v2', p === 'leaders');
  document.body.classList.toggle('on-marathon-v2', p === 'marathon');

  if (p === 'oqu')     import('../features/oqu/index.js').then(m => m.loadOqu());
  if (p === 'shelf')   import('../features/shelf/index.js').then(m => m.loadShelf()).catch(() => {});
  if (p === 'jandos')  loadJandos();
  if (p === 'marathon') loadMarathon();
  if (p === 'blogger')  import('../features/blogger/index.js').then(m => m.loadBlogger()).catch(() => {});
  if (p === 'public-profile') loadPublicProfile();
  if (p === 'feed')    loadFeed();
  if (p === 'leaders') loadLeaders('streak');
  if (p === 'groups')  loadGroups();
  if (p === 'achieve') renderAchievements();
  if (p === 'catalog') { loadGenres(); loadCatalog(); }
  if (p === 'profile') loadProfile();
  if (p === 'wrapped') loadWrapped();
  if (p === 'wrapped-monthly') loadMonthlyWrapped();
  if (p === 'dawys')   loadDawysPage();
  if (p === 'admin')   loadAdmin();

  // Stage 8 v2 IA: профіль навтан алынды → әр беттегі аватарды толтыру.
  paintAvatars();

  // ❗22.09: бет түсіндірмелері АЛЫНДЫ (founder). Бесеуі де (Оқу, Кітапхана,
  // Бірге, Парақтау, Профиль) кезекке тіркелмей, әр жаңа бетте тікелей
  // экранға шығатын. Адам табтарды аралағанда қатарынан бес терезе алатын.
  // Түсінік керек болса — ол беттің ӨЗІНДЕ бір жол мәтін болады.

  window.scrollTo(0, 0);
}

// Stage 8 v2 IA: қолданушының бас әріптері (аватар үшін). Profile навтан
// алынып, әр беттің жоғарғы оң бұрышындағы [data-pq-av] аватарына қойылады.
export function pqInitials() {
  const u = window.currentUser || {};
  const nm = String(u.first_name || u.name || u.username || '').trim();
  const ln = String(u.last_name || '').trim();
  let s = '';
  if (nm) s += nm[0];
  if (ln) s += ln[0];
  if (!s && nm) s = nm.slice(0, 2);
  return (s || '🙂').toUpperCase();
}

export function paintAvatars() {
  if (!window.currentUser) return;
  const ini = pqInitials();
  document.querySelectorAll('[data-pq-av]').forEach(el => { el.textContent = ini; });
}

// ❗22.09: `PAGE_HINTS` пен `showPageHint` ТОЛЫҒЫМЕН ӨШІРІЛДІ.
// Бес бет түсіндірмесі (Оқу · Кітапхана · Парақтау · Профиль · Клубтар)
// кезекке тіркелмей, `show()` сайын 650 мс кейін тікелей экранға шығатын.
// Жаңа адам табтарды аралағанда қатарынан бес терезе алатын. Ереже:
// түсінік беттің өзінде тұрады, жолды бөгейтін терезе болмайды.

export function showTab(p, btn) {
  show(p);
  document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('on'));
  if (btn) btn.classList.add('on');
}

export function showTab2(p, btn) {
  show(p);
  document.querySelectorAll('.mob-tab2').forEach(b => b.classList.remove('on'));
  if (btn) btn.classList.add('on');
}
